import * as preact from "preact";

import models from "models/models";
import * as practiceUtils from "practiceUtils";
import readlangClient from "readlangClient";
import { cn } from "shared/utils";

interface Props {
  vocab: {
    word: string;
    context: string;
    translation: string;
    toSave: boolean;
  }[];
  onToggle: (index: number) => void;
  selectAll: (value: boolean) => void;
  userChatID: string;
  appRouter: any;
}

interface State {
  saving: boolean;
}

class VocabSelector extends preact.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { saving: false };
  }

  toggleWord = (index: number) => {
    this.props.onToggle(index);
  };

  render() {
    const allSelected = this.props.vocab.every((item) => item.toSave);
    return (
      <div className="vocabSelector">
        <h3>Save Vocab?</h3>
        <table className="vocabTable">
          {this.props.vocab.length > 1 ? (
            <tr>
              <td></td>
              <td class="selectAllLabelCell">
                <label for="selectAll">Select all</label>
              </td>
              <td>
                <input
                  id="selectAll"
                  type="checkbox"
                  checked={allSelected}
                  onChange={() => {
                    if (allSelected) {
                      this.props.selectAll(false);
                    } else {
                      this.props.selectAll(true);
                    }
                  }}
                />
              </td>
            </tr>
          ) : null}
          {this.props.vocab.map((vocabItem, index) => {
            const clozeSentence = practiceUtils.buildClozeSentence(
              vocabItem.context,
              vocabItem.word,
              false
            );

            return (
              <tr
                className={cn({
                  vocabItem: true,
                  selected: vocabItem.toSave,
                })}
              >
                <td
                  class="word"
                  onClick={() => {
                    this.toggleWord(index);
                  }}
                >
                  {clozeSentence.map((part) =>
                    part.type === "target" ? (
                      <strong>{part.text}</strong>
                    ) : (
                      <>{part.text}</>
                    )
                  )}
                </td>
                <td
                  class="translation"
                  onClick={() => {
                    this.toggleWord(index);
                  }}
                >
                  {vocabItem.translation}
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={vocabItem.toSave}
                    onChange={() => {
                      this.toggleWord(index);
                    }}
                  />
                </td>
              </tr>
            );
          })}
        </table>
        <button
          class="prominent"
          disabled={
            this.state.saving ||
            this.props.vocab.filter((item) => item.toSave).length === 0
          }
          onClick={() => this.saveVocabAndPractice()}
        >
          Practice Now
        </button>
        <button
          disabled={
            this.state.saving ||
            this.props.vocab.filter((item) => item.toSave).length === 0
          }
          onClick={async () => {
            await this.saveVocab();
            alert("Vocab saved to your account!");
          }}
        >
          Save To Practice Later
        </button>
        <p style={{ marginBottom: 0 }}>
          <small>
            This only includes corrections of your own writing. If you
            translated some of Ami's messages, these will have been saved to
            your account already, just like how Readlang works when reading
            other texts.
          </small>
        </p>
      </div>
    );
  }

  async saveVocab() {
    await this.setState({ saving: true });

    // Save to the user's account
    const userWordIDs = await Promise.all(
      this.props.vocab
        .filter((item) => item.toSave)
        .map(async (vocabItem) => {
          const response = await readlangClient.request(
            "POST",
            "/api/userWord",
            {
              word: vocabItem.word,
              translation: vocabItem.translation,
              language: models.user.get("currentLearningLanguage"),
              contexts: [
                {
                  text: vocabItem.context,
                  userChatID: this.props.userChatID,
                },
              ],
            }
          );
          return response.data.upserted ?? response.data.updated;
        })
    );

    await this.setState({ saving: false });

    return userWordIDs;
  }

  async saveVocabAndPractice() {
    const userWordIDs = await this.saveVocab();

    const practiceURL = `/practice/words/${userWordIDs.join("|")}?from=chat`;

    // Go to practice page
    this.props.appRouter.navigate(practiceURL, {
      trigger: true,
    });
  }
}

export default VocabSelector;
